// extracted by mini-css-extract-plugin
module.exports = {"errorPageHolder":"TimeoutErrorPage_errorPageHolder__2QyuC","showboatLogo":"TimeoutErrorPage_showboatLogo__1fN_7"};